// extracted by mini-css-extract-plugin
module.exports = {"Description":"DataNotFound_Description__DzTez"};